import WiretapApp from 'bam-wiretap/WiretapApp';
import trackingJson from './configs/nav-tracking.json';

const sectionTracker = new WiretapApp(trackingJson, setCustomTrackingVars, {});

/**
 * Set the variables inside the tracking event object.
 * Should be overridden by the custom section implementations.
 * @param  {object} trackObj Config properties.
 * @param  {jquery} $el      The jquery event element.
 */
function setCustomTrackingVars(trackObj, $el) {
    const _this = this;
    const pageMeta = window.pageMeta;
    const siteName = pageMeta.siteName;
    const pageSection = pageMeta.page_section;
    const pageName = pageMeta.page_name;

    // Replace any variables within each prop value.
    $.each(trackObj, (prop, val) => {
        let value = val.toString();
        const nav = window.innerWidth < 1024 ? 'sidebar' : 'topbar';

        if (value.indexOf('@') !== -1) {
            if (value.match(/@SITENAME@/)) {
                value = value.replace(/@SITENAME@/, siteName);
            }
            if (value.match(/@PAGESECTION@/)) {
                value = value.replace(/@PAGESECTION@/, pageSection);
            }
            if (value.match(/@PAGENAME@/)) {
                value = value.replace(/@PAGENAME@/, pageName);
            }
            if (value.match(/@NAV@/)) {
                value = value.replace(/@NAV@/, nav);
            }
            if (value.match(/@HAMBURGER@/)) {
                const hamburger = $el.hasClass('open') ? 'open' : 'close';
                value = value.replace(/@HAMBURGER@/, hamburger);
            }
            if (value.match(/@NAVHEADER@/)) {
                const navHeader = (nav === 'sidebar') ?
                $el.children('a').find('span').text().trim() :
                $el.children('a').text().trim();
                value = value.replace(/@NAVHEADER@/, navHeader);
            }
            if (value.match(/@HASSUBNAV@/)) {
                let hasSubNav = $el.hasClass('active') ? ' close' : ' open';
                hasSubNav = (nav === 'sidebar') ? hasSubNav : '';
                value = value.replace(/@HASSUBNAV@/, hasSubNav);
            }
            if (value.match(/@PARENTHEADER@/)) {
                let parentHeader = (nav === 'sidebar') ?
                $el.parent().siblings('a').find('span').text().trim() :
                $el.parent().siblings('a').text().trim();
                parentHeader = ($el.parent().hasClass('header__nav-item-body--more')) ? 'MORE' : parentHeader;
                value = value.replace(/@PARENTHEADER@/, parentHeader);
            }
            if (value.match(/@SUBNAV@/)) {
                const subNav = $el.text().trim();
                value = value.replace(/@SUBNAV@/, subNav);
            }
            if (value.match(/@SOCIAL@/)) {
                const social = $el.data('social');
                value = value.replace(/@SOCIAL@/, social);
            }

            trackObj[prop] = value;

        }

        // Remove any bad props.
        if (trackObj[prop] === 'undefined' || trackObj[prop] === null) {
            delete trackObj[prop];
        }
    });

    return trackObj;
}

export default sectionTracker;
